module.exports = __webpack_public_path__ + "img/jupiter.be5030ca.webp";